import React, { useContext, useState, useEffect } from 'react'
import { QuestionContext } from '../../../../Context'
import { ErrorText } from './styles'

type ErrorProps = {
  questionId: string
}

export const ErrorCon: React.FC<React.PropsWithChildren<ErrorProps>> = ({
  questionId,
}) => {
  const { error } = useContext(QuestionContext)!
  const [errorMsg, setErrorMsg] = useState<string>('')

  useEffect(() => {
    checkForError()
  }, [error])

  const checkForError = () => {
    if (error) {
      const e = Object.keys(error).find((k) => k === questionId)
      if (e) {
        setErrorMsg(error[e].message)
        setTimeout(() => {
          setErrorMsg('')
        }, 5000)
      }
      return
    }
  }

  return <>{errorMsg && <ErrorText>{errorMsg}</ErrorText>}</>
}
